import axios from 'axios';
import { getApiUrl } from '../../../config';

export function requestGetVapidPublicKey() {
    return axios.request({
        method: 'get',
        url: `${getApiUrl()}/push/vapid-public-key`,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestSubscribePush(subscriptionData) {
    return axios.request({
        method: 'post',
        url: `${getApiUrl()}/push/subscribe`,
        data: subscriptionData,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestUnsubscribePush(endpoint) {
    return axios.request({
        method: 'post',
        url: `${getApiUrl()}/push/unsubscribe`,
        data: { endpoint },
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGetPushStatus() {
    return axios.request({
        method: 'get',
        url: `${getApiUrl()}/push/status`,
        withCredentials: true,
        crossorigin: true,
    });
}
